export default __webpack_public_path__ + "static/media/share_hover_toggle.50d9dcee.svg";